
import Vue from 'vue'
import moment from 'moment'
import store from '@/store/store'
import { format } from '@/directives/v-formatMoney/utils' //busca da diretiva v-formatMoney
import cnpjUtils from '@/utilities/cnpj' // CPF/CNPJ (compatível com CNPJ alfanumérico)

function validateToken(date) {

    const expirationToken = moment(new Date(date));
    const now = moment();
    const diff = expirationToken.diff(now, 'seconds');

    if (diff > 0)
        return true
    else
        return false
}

function showToast(state, title, content) {
    console.log(content);
}

export default {

    data() {
        return {
            Meses: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
            mascaraCnpj: cnpjUtils.MASCARA_CNPJ,
        }
    },
    methods: {
        showLoading: function () {
            this.$store.commit('Loader', true);
        },
        hideLoading: function () {
            this.$store.commit('Loader', false);
        }, 
        showDialog: function (text, func, params) {
            const options = {
                html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
                loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
                reverse: false, // switch the button positions (left to right, and vise versa)
                okText: 'OK',
                cancelText: 'Cancelar',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            };

            this.$dialog.confirm(text, options)
                .then(() => func(params))
                .catch(function () {
                    console.log('Clicked on cancel');
                });
        },
        showToast: function (state, title, content) {

            switch (state) {
                case "info":
                    this.$toast.info(content, title);
                    break;
                case "warning":
                    this.$toast.warning(content, title);
                    break;
                case "error":
                    this.$toast.error(content, title);
                    break;
                case "success":
                    this.$toast.success(content, title);
                    break;
                default:
                    break;
            }
        },
        formatarApenasNumero: function (data) {
            return data.replace(/\D/g, '')
        },
        isCpf: function (cpf) {
            if (cpf === "00000000000" || cpf === "11111111111" || cpf === "22222222222" || cpf === "33333333333"
                || cpf === "44444444444" || cpf === "55555555555" || cpf === "66666666666" || cpf === "77777777777"
                || cpf === "88888888888" || cpf === "99999999999"
            ) return false;

            if (cpf.length !== 11) return false;
            let Soma = 0;
            let Resto;
            let i;

            for (i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(cpf.substring(9, 10))) return false;

            Soma = 0;
            for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(cpf.substring(10, 11))) return false;

            return true;
        },
        // Compatível com CNPJ alfanumérico (não remove letras nem converte para número).
        isCnpj: function (cnpj) {
            return cnpjUtils.isCnpjValido(cnpj);
        },
        normalizarCpfCnpj: function (documento) {
            return cnpjUtils.normalizarCpfCnpj(documento);
        },
        normalizarCnpj: function (cnpj) {
            return cnpjUtils.normalizarCnpj(cnpj);
        },
        formatarCnpj: function (cnpj) {
            return cnpjUtils.formatarCnpj(cnpj);
        },
        isCep: function (cep) {
            const cepFormatado = this.formatarApenasNumero(cep);
            return cepFormatado.length == 8;
        },

        isUrl(url) {  

            if(url == ""){return true;}

            const pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            return pattern.test(url);
          },

          validarIdade(dataString, nome, idadeMinima){
            const idade = this.calcularIdade(dataString);
      
            if(idade == undefined || idade == null){
              this.showToast("warning", "Atenção!", "Idade do '" + nome + "' é inválida.");
              return false;
            }
      
            if(idade < idadeMinima){
              this.showToast("warning", "Atenção!", "Apenas maiores de " + idadeMinima + " anos podem ser '"+nome+"'.");
              return false;
            }  
            
            return true;
          },

          validarNumeroCelular: function(celularString, nome) {
            let celularSomenteNumero = this.formatarApenasNumero(celularString);

            ///Considero o DDD
            if(celularSomenteNumero.length != 11){
              this.showToast("warning", "Atenção!", "Número de celular do " + nome + " é inválido, verifique se foi informado o DDD.");
              return false;
            }
    
            let numeroCelularInicial = celularSomenteNumero.substring(2,3);
    
            if(numeroCelularInicial == "9" || numeroCelularInicial == "8" || numeroCelularInicial == "7"){
                return true;
            }
    
            this.showToast("warning", "Atenção!", "Número de celular do " + nome + " é inválido.");
            return false;
        },

          ///Enviar uma data no padrao BR dd/mm/aaaa
          calcularIdade: function(dataString) { 

            const dataSplit = dataString.split('/');
      
            if(dataSplit.length != 3){
              return null;
            }
      
            let data = new Date(dataSplit[2], dataSplit[1], dataSplit[0]);
            const diff = Date.now() - data.getTime();
            const diffIdade = new Date(diff); 
        
            let idade = Math.abs(diffIdade.getUTCFullYear() - 1970);
            console.log(idade);
            return idade;
          },

        obterEndereco(cep) {
            cep = cep.replace('-', '');

            if (this.isCep(cep) === false) {
                this.mensagem = 'Cep ' + cep + ' inválido.';
                this.sucesso = false;
                return;
            }

            return this.$httpPbs.get('/Cep/Consultar/' + cep);
        },

        obterDadosPessoaisX(documento){
            documento = this.formatarApenasNumero(documento);
            let tipoPessoa = documento.length < 14 ? 'PF' : 'PJ';
            const motorBusca = 2; // 2 - Diretrix || 1 - unitfour

            this.$httpPbs
                .get("pessoa/BuscaCPFCNPJ/"+documento+"/"+tipoPessoa+"/"+motorBusca)
                .then(response => {
                    console.log(response.data.data);
                })
                .catch(error => {
                    console.log(error.response);
                    return null;
                });          
        },

         obterCNAEX: async function(codigo) {
            codigo = this.formatarApenasNumero(codigo);
            const url = 'classificacao/AtividadeTecnica/' + codigo;

            this.$httpPbs.get(url).then(response => {
              console.log(response);
              return response;
            }).catch( error => {
                      console.log(error.response);
                      return Promise.reject(new Error(error.response))
            });      
          },

        ///Enviar uma data no padrao BR dd/mm/aaaa
        formatarDataParaDB: function(dataString)
          {

              if(dataString == "" || dataString == undefined) return "";

              const dataSplit = dataString.split('/');
      
              if(dataSplit.length != 3){
                return null;
              }
        
              return dataSplit[2] + "/" + dataSplit[1] + "/" + dataSplit[0];
        },          

        FormatarData: function(textoData)
        {
            if(textoData == "" || textoData == undefined) return "";
            const _data = new Date(textoData);
            return ("0" + _data.getDate()).slice(-2) + "/" + this.Meses[_data.getMonth()] + "/" + _data.getFullYear(); 
        },
        FormatarDataNula: function(textoData)
        {
            if(textoData == null)
            {
                return "N/A";
            }
            else
            {
                const _data = new Date(textoData);
                return ("0" + _data.getDate()).slice(-2) + "/" + this.Meses[_data.getMonth()] + "/" + _data.getFullYear();     
            }
        },        
        // Máscara de CPF/CNPJ por posição; compatível com CNPJ alfanumérico (letras preservadas).
        formatarCpfCnpj(cpfCnpj){
            return cnpjUtils.formatarCpfCnpj(cpfCnpj);
        },
        obterParametrosURL() {
            const vars = {};
            window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });
            return vars;
        },
        notificacaoWindows: function(textoNotificacao) {
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
            }
            else if (Notification.permission === "granted") {
                const notification = new Notification(textoNotificacao);
            }
            else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        const notification = new Notification(textoNotificacao);
                    }
                });
            }

            // At last, if the user has denied notifications, and you 
            // want to be respectful there is no need to bother them any more.
        },    
        
        parseJwt (token) {
            const base64Payload = token.split('.')[1];
            const payload = Buffer.from(base64Payload, 'base64');
    
            return JSON.parse(payload.toString());
          },
    
          parseJwtToUser (token) {
                let payload = this.parseJwt(token);

                if(payload == null){
                    let corretorToken = {
                        codCorretor: localStorage.getItem("codCor"),
                        nome: localStorage.getItem("nome"),
                        email: localStorage.getItem("email"),
                        tipoLogin: localStorage.getItem("tipo"),
                        permissoes: (() => {
                            const bruto = localStorage.getItem("permissoes");
                            if (!bruto || bruto === "undefined") return "";
                            try { return JSON.parse(bruto); } catch (e) { return ""; }
                        })(),
                        idLogin: localStorage.getItem("userId"),
                        emailAuxiliar: localStorage.getItem("email"),
                        degustacao: '0',	
                    };                    
                    return null;
                }
    
                const dadosToken = payload.unique_name.split(":");
    
                if(dadosToken.length == 0){
                  return null;
                }
                
                let corretorToken = {
                    codCorretor: dadosToken[0],
                    nome: dadosToken[1].trim(),
                    email: dadosToken[2],
                    tipoLogin: dadosToken[3],
                    permissoes: dadosToken[4],
                    idLogin: dadosToken[5],
                    emailAuxiliar: dadosToken[6],
                    degustacao: dadosToken[7],	
                };
    
                return corretorToken;
          },
    
          parseJwtToUserFromStorage () {
              let token = localStorage.getItem("cota_mais_token");
    
              if(token == "" || token == undefined){
                return null;
              }
              
              return this.parseJwtToUser(token);
          },        
    }
}

export {
    validateToken, showToast
}